module.exports = __webpack_public_path__ + "static/media/logo.7b257169.jpg";